import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { shape, string } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMobileAlt,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";
import SocialMedia from "./social-media";

const Contact = ({ contact, title, text }) => {
  return (
    <section id="contact" className="page-section text-center bg-color-1">
      <Container>
        <h2>{title}</h2>
        <hr className="small" />
        <SocialMedia />

        <p className="lead mt-4">{text}</p>

        <Row className="mt-5">
          <Col sm>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} size="2x" />
              <p className="lead">{contact.phone}</p>
            </div>
          </Col>
          <Col sm>
            <div className="contact-item">
              <FontAwesomeIcon icon={faMobileAlt} size="2x" />
              <p className="lead">{contact.mobile}</p>
            </div>
          </Col>
          <Col sm>
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} size="2x" />
              <p className="lead">
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

Contact.propTypes = {
  contact: shape({
    phone: string.isRequired,
    mobile: string.isRequired,
    email: string.isRequired
  }).isRequired,
  text: string.isRequired,
  title: string.isRequired
};

export default Contact;
